export const DEVICE_RESULT_HEADER = 'devices-result-header';
export const DEVICE_RESULT_GROUP = 'devices-result-group';
